var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 20,
    viewBox: "0 0 180 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CDCDCD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.528 1.982l.034.142 1.979 10c.214 1.084-.49 2.136-1.574 2.35-1.035.205-2.04-.428-2.316-1.428l-.034-.145-1.11-5.611L8.953 144.503l5.92-1.4c1.027-.242 2.055.354 2.367 1.343l.04.144c.254 1.075-.411 2.153-1.486 2.407l-10.55 2.494c-1.102.26-2.201-.447-2.421-1.559l-1.98-10c-.213-1.083.491-2.135 1.575-2.35 1.083-.214 2.135.49 2.35 1.574l.978 4.949L97.743 5.715l-5.232 1.238c-1.026.242-2.054-.353-2.367-1.343l-.04-.144c-.242-1.026.353-2.054 1.343-2.366l.144-.04L102.14.566c1.055-.25 2.106.387 2.388 1.416z",
    transform: "translate(-764 -2838) translate(598 2517) rotate(56 -85.818 392.794)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow-2.ef06a449.svg";
export { ForwardRef as ReactComponent };